export default "__VITE_ASSET__e0d8K_Bs__"